import ToastificationContent from "@/@core/components/toastification/ToastificationContent.vue";
import store from "@/store";
import { useToast } from "vue-toastification/composition";


const useTaxiJuraApp = () => {
    const toast = useToast();

    const enrolToTaxiJuraApp = async (enrolMember) => {
        try {
          return await store.dispatch('taxi/enrolTaxiToJuraApp', enrolMember);
        } catch (error) {
          toast.error({
            component: ToastificationContent,
            props: {
              title: error.response.data?.detail || 'Error enrolling the taxi',
              icon: 'XCircleIcon',
            },
          });
          return null;
        }
      };

      const getTaxiJuraApp = async (licenceNum) => {
        try {
          return await store.dispatch('taxi/getDetailsTaxiToJuraApp', licenceNum);
        } catch (error) {
          toast.error({
            component: ToastificationContent,
            props: {
              title: error.response.data?.detail || 'Error fetching taxi details for Jura App',
              icon: 'XCircleIcon',
            },
          });
          return null
        }
      }

      const modifyJuraAppTaxiData = async (onlineAppMemberData) => {
       try{
          return await store.dispatch('taxi/modifyTaxiDetailsJuraApp', onlineAppMemberData);
        } catch (error) {
          toast.error({
            component: ToastificationContent,
            props: {
              title: error.response.data?.detail || 'Error updating taxi details for Jura App',
              icon: 'XCircleIcon',
            },
          });
          return null
        }
      }
           
      return {
        enrolToTaxiJuraApp,
        getTaxiJuraApp,
        modifyJuraAppTaxiData
      }
}

export default useTaxiJuraApp;